import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const STATUS_OPTIONS = [{ value: 'single' }, { value: 'married' }, { value: 'divorced' }, { value: 'widowed' }];

export default function StatusSelect({ value, onChange, error }) {
  const { t } = useTranslation();

  return (
    <>
      <Box display="flex" gap={1} flexWrap="wrap">
        {STATUS_OPTIONS.map((option) => {
          const isActive = value === option.value;

          return (
            <Button
              key={option.value}
              onClick={() => onChange?.(option.value)}
              sx={(theme) => ({
                padding: '12px 24px',
                outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
                borderRadius: '14px',
                color: isActive ? '#fff' : 'rgb(0,0,0)',
                backgroundColor: isActive ? theme.palette.secondary.main : '#fff',
                '&:hover': {
                  color: '#fff',
                  backgroundColor: theme.palette.secondary.main + 'CC',
                  outline: isActive ? `1px solid ${theme.palette.secondary.main}` : '1px solid #DCE4E8',
                },
              })}
            >
              {t(option.value)}
            </Button>
          );
        })}
      </Box>

      {error && (
        <Typography variant="caption" color="error">
          {error.message}
        </Typography>
      )}
    </>
  );
}
